import { NumeralDayOfMonth, WeekDay } from '@store/common/schedule.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { Document } from '@store/documents';
import { DocumentInfo } from '@store/files';
import { Container } from '@store/settings/containers';
import { User } from '@store/settings/users';
import { Waste } from '@store/settings/wasteFamilies';
import I18n from '@utils/i18n.utils';

export enum AuditOperationStatusEnum {
    VALIDATED = 'VALIDATED',
    OPTIMIZED = 'OPTIMIZED',
    CREATED = 'CREATED',
}

export interface AuditOperationFilters {
    search: string;
    tableFilters: TableFilter[];
  }

export namespace AuditOperationFilters {
    export const initTableFilters = () => TableFilterType.initTableFilters([
      TableFilterType.CONTAINER,
      TableFilterType.WASTE,
    ]);
  }
  

export enum AuditOperationStepTypeEnum {
    AUDIT = 'AUDIT',
    PRECO = 'PRECO',
    CONTRACT = 'CONTRACT',
}
export interface SearchAuditStepOperationDto {
    step?: AuditOperationStepTypeEnum;
    containerId?: number;
    wasteId?: number;
}
export enum AuditOwnedByEnum {
    SUPPLIER = 'SUPPLIER',
    CLIENT = 'CLIENT',
    UNKNOWN = 'UNKNOWN',
}

export namespace AuditOwnedBy {
    export const selectItems = () => [
        { label: I18n.t('global.userType.supplier'), value: AuditOwnedByEnum.SUPPLIER },
        { label: I18n.t('global.userType.client'), value: AuditOwnedByEnum.CLIENT },
        { label: I18n.t('global.userType.unknown'), value: AuditOwnedByEnum.UNKNOWN },
    ];
}



export interface AiScheduleObj {
    frequencyType: string;
    frequencyItem: AiScheduleItem[];
}
export interface AiScheduleItem {
    title: string;
    value?: string | number;
    oldValue?: string | number;
}

export namespace AuditOperationType {
    export const selectItems = () => [
        { label: I18n.t('global.classic'), value: AuditOperationTypeEnum.CLASSIC },
        { label: I18n.t('global.custom'), value: AuditOperationTypeEnum.CUSTOM },
    ];
}

export enum AiScheduleEnum {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
}

export enum AuditOperationTypeEnum {
    CLASSIC = 'CLASSIC',
    CUSTOM = 'CUSTOM',
}

export interface AuditOperationScheduleDto {
    frequency?: AiScheduleEnum;
    dayOfMonth?: number; // MENSUEL
    isDayOfMonth?: boolean;
    monthlyFrequencyNumber?: number; // MENSUEL
    weeklyFrequencyNumber?: number; // HEBDOMADAIRE
    daysOfWeek?: string; // HEBDOMADAIRE
    dailyFrequencyNumber?: number; // QUOTIDIEN  -- IF -1 -> every working days
    dailyEveryWeekDay?: boolean;
    numeralDayOfMonth?: NumeralDayOfMonth;
    weekDayForMonth?: WeekDay;
}

export interface CreateAuditOperation extends Partial<AuditOperation> {
    by?: AuditOwnedByEnum;
    whereIs?: string;
    wasteUnit?: string;
    frequency?: AuditOperationScheduleDto;
    addedDocuments?: DocumentInfo[];
    deletedDocuments?: number[];
}


export interface AuditOperation {
    id: number;
    quantity: number;
    ownedBy: AuditOwnedByEnum;
    description: string;
    wasteQuantity: number;
    containerCustom?: string;
    wasteCustom?: string;
    annualEstimatedWeightInTons: number;
    wasteUnitName: string;
    schedule: string;
    stepType: AuditOperationStepTypeEnum;
    oldValue: string;
    container: Container;
    containerId: number;
    auditId: number;
    wasteId: number;
    status: AuditOperationStatusEnum;
    waste: Waste;
    documents: string[] | Document[];
    type: AuditOperationTypeEnum;
    author?: User;
}
